import axios from 'axios';

const baseURL = process.env.CONTENT_ENGINE_URL;
const contentBaseUrl = `${baseURL}/app/content`;

function moduleUrl(moduleId, branchName) {
    return `${contentBaseUrl}/module/${moduleId}/branch/${branchName}`;
}

function visiblePageUrl(moduleId, pagePath, visible) {
    return `${contentBaseUrl}/module/${moduleId}/toc/page/${pagePath}/visible/${visible}`;
}

function visibleTOCUrl(moduleId) {
    return `${contentBaseUrl}/module/${moduleId}/toc/page`;
}


export default {
    // GET /app/content/module
    async getActivatedCEModules() {
        return axios.get(`${contentBaseUrl}/module`);
    },

    // GET /app/content/module/{moduleId}/branch/{branchName}/toc
    async getToc(moduleId, branchName) {
        return axios.get(`${moduleUrl(moduleId, branchName)}/toc?json=true`);
    },

    async setTOCVisible(moduleId, rootPath, visiblePagePaths) {
        // Set all to false
        await axios.put(`${visiblePageUrl(moduleId, rootPath, false)}`);
        const tocVisibility = visiblePagePaths.map((e) => {
            return { path: e, visible: true };
        });

        await axios.put(`${visibleTOCUrl(moduleId)}`,
            {
                pages: tocVisibility
            }
        ); // eslint-disable-line
    },

    // FIXME: Concurrency issue
    // The backend requires multple calls to be sequential due to concurrency
    // issues. This two bulk functions are inefficient and should be handled
    // on the backend
    // GET /app/content/module/{moduleId}/toc/page/{pagePath}/visible/{visibility}
    async setMultipleVisible(moduleId, rootPath, visiblePagePaths) {
        await axios.put(`${visiblePageUrl(moduleId, rootPath, false)}`);
        for (const page of visiblePagePaths) { // eslint-disable-line
            await axios.put(`${visiblePageUrl(moduleId, page, true)}`); // eslint-disable-line
        }
    },

    // GET /app/content/module/{moduleId}/toc/page/{pagePath}/visible/{visibility}
    // In most cases suspect more efficient to make multiple INvisible.
    // Users likely hide fewer policy paths in a module than are shown
    // resulting in fewer sequential calls.
    // However, for this to work the array must be in parent->child border
    // Setting parent visiblity on backend sets cascades to children
    async setMultipleInvisible(moduleId, rootPath, invisiblePagePaths) {
        await axios.put(`${visiblePageUrl(moduleId, rootPath, true)}`);
        for (const page of visiblePagePaths) { // eslint-disable-line
            await axios.put(`${visiblePageUrl(moduleId, page, false)}`); // eslint-disable-line
        }
    },

    // GET /app/content/module/{moduleId}/branch/{branchName}/toc
    async setVisible(moduleId, pagePath, visible) {
        return axios.put(`${visiblePageUrl(moduleId, pagePath, visible)}`);
    },

    // GET /app/content/module/{moduleId}/branch/{branchName}/page/{pagePath}
    async getPage(moduleId, branchName, pagePath, includeChildren) {
        return axios.get(`${moduleUrl(moduleId, branchName)}/page/${pagePath}?includeChildren=${includeChildren ? 'true' : 'false'}`);
    }

};



// WEBPACK FOOTER //
// ./src/api/content.js